export function getHostedVideoEmbedUrl(videoUrl: string): string | null {
  try {
    const parsed = new URL(videoUrl.trim());
    const hostname = parsed.hostname.toLowerCase().replace(/^www\./, '');

    if (hostname === 'youtube.com' || hostname === 'youtube-nocookie.com') {
      const pathParts = parsed.pathname.split('/').filter(Boolean);
      const videoId = parsed.searchParams.get('v') ||
        (pathParts[0] === 'shorts' || pathParts[0] === 'embed' ? pathParts[1] : null);
      return videoId ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` : null;
    }

    if (hostname === 'youtu.be') {
      const videoId = parsed.pathname.split('/').filter(Boolean)[0];
      return videoId ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}` : null;
    }

    if (hostname === 'vimeo.com') {
      const videoId = parsed.pathname.split('/').filter(Boolean)[0];
      return videoId && /^\d+$/.test(videoId) ? `https://player.vimeo.com/video/${videoId}` : null;
    }
  } catch {
    return null;
  }

  return null;
}
